<div class="flex flex-col flex-auto task-form-wrapper">
  <form [formGroup]="taskForm">
    <div class="header w-full">
      <!-- Mark as ... button -->
      <span class="px-4">
        <strong>Task: </strong>
        <label>&nbsp;{{ getTaskStatus(taskForm.get('workflow_state').value)?.label }}</label>
      </span>

      <!-- More menu -->
      <button
        class="more-menu"
        mat-icon-button
        [matMenuTriggerFor]="moreMenu"
        [appAuthorize]="NewPermission.AGGREGATED_TASK_LISTS_DELETE"
        [disabled]="!canEdit"
      >
        <mat-icon [svgIcon]="'more_vert'"></mat-icon>
      </button>

      <mat-menu #moreMenu="matMenu">
        <button mat-menu-item (click)="deleteTask()">
          <mat-icon [svgIcon]="'delete'"></mat-icon>
          <span>Delete task</span>
        </button>
      </mat-menu>

      <!-- Close button -->
      <button mat-icon-button (click)="closeDrawer()">
        <mat-icon [svgIcon]="'close'"></mat-icon>
      </button>
    </div>

    <mat-divider class="mt-0"></mat-divider>

    <!-- Title -->
    <div class="title">
      <mat-form-field class="treo-mat-textarea treo-mat-no-subscript">
        <mat-label>{{ task.task_type === 'task' ? 'Task title' : 'Section title' }}</mat-label>
        <textarea matInput treoAutogrow [formControlName]="'title'" [spellcheck]="false" #titleField></textarea>
      </mat-form-field>
    </div>
    <div class="contacts my-3">
      <div class="flex flex-auto justify-between items-center">
        <mat-form-field class="w-full field treo-mat-no-subscript">
          <mat-label>Contacts</mat-label>
          <mat-chip-list #chipList aria-label="User selection" class="mat-chip-list" [disabled]="!canEdit">
            <mat-chip
              *ngFor="let user of selectedUsers"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="removeUser(user)"
            >
              {{ user.name }}
              <mat-icon matChipRemove *ngIf="removable" class="m-0">cancel</mat-icon>
            </mat-chip>
            <input
              placeholder="Add Contacts..."
              #userInput
              [formControl]="userCtrl"
              [matAutocomplete]="auto"
              [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            />
          </mat-chip-list>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedUser($event)">
            <mat-option *ngFor="let user of contactList" [value]="user.name" [id]="user.id">
              {{ user.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
    <div class="title mt-3">
      <mat-form-field class="flex-auto gt-xs:pr-3">
        <mat-label>Status </mat-label>
        <mat-select [formControlName]="'workflow_state'" [panelClass]="'task-status-selector'">
          <mat-select-trigger>
            <span class="calendar-color" [ngClass]="getTaskStatus(taskForm.get('workflow_state').value)?.color"></span>
            <span class="calendar-title">{{ getTaskStatus(taskForm.get('workflow_state').value)?.label }}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let state of workflowStates" [value]="state.key">
            <span class="calendar-color" [ngClass]="state.color"></span>
            {{ state.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Priority and Due date -->
    <div class="priority-and-due-date mt-2">
      <div class="priority">
        <mat-form-field class="treo-mat-no-subscript">
          <mat-label>Assigned To</mat-label>
          <mat-select [formControlName]="'assigned_user_id'">
            <mat-option *ngFor="let user of users" [value]="user.id" [disabled]="!user?.active">
              {{ user.full_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Due date -->
      <div class="due-date">
        <div class="label">Due date</div>
        <button
          mat-button
          [ngClass]="{ overdue: isOverdue(), 'due-set': task.due_date }"
          (click)="openDueDatePanel()"
          [disabled]="!canEdit"
          #dueDatePanelOrigin
        >
          <mat-icon [svgIcon]="'today'"></mat-icon>

          <span *ngIf="task.due_date">{{ task.due_date | date: 'longDate' }}</span>
          <span *ngIf="!task.due_date">Not set</span>
        </button>
      </div>

      <!-- Time -->
      <div class="due-date due-time">
        <div class="label">Time</div>
        <input
          [ngxTimepicker]="toggleTimepicker"
          [ngClass]="{ 'due-set': task.due_date }"
          placeholder="Not set"
          aria-label="Not set"
          [value]="task.due_date | date: 'shortTime'"
          [disableClick]="true"
          readonly
          class="tm-input"
        />
        <ngx-material-timepicker-toggle
          [for]="toggleTimepicker"
          class="tm-picker"
          [disabled]="!canEdit"
        ></ngx-material-timepicker-toggle>
        <ngx-material-timepicker
          #toggleTimepicker
          [enableKeyboardInput]="true"
          [minutesGap]="5"
          [theme]="darkTheme"
          (timeSet)="taskTimeChanged($event)"
          timepickerClass="cp-timer-container"
        ></ngx-material-timepicker>
      </div>

      <!-- Due date panel -->
      <ng-template #dueDatePanel>
        <div class="tasks-details-due-date-panel">
          <mat-calendar
            [selected]="taskForm.get('due_date').value"
            [startAt]="taskForm.get('due_date').value"
            (selectedChange)="updateDueDate($event)"
          ></mat-calendar>

          <button mat-stroked-button *ngIf="taskForm.get('due_date').value" (click)="removeDueDate()">
            <mat-icon [svgIcon]="'remove_circle'"></mat-icon>
            Remove due date
          </button>
        </div>
      </ng-template>
    </div>
    <!--<div class="flex flex-col gt-xs:flex-row mt-2">
            <input [formControlName]="'project_id'" type='hidden'>
            <mat-form-field class="flex-auto gt-xs:pr-3">
                <mat-label>Associated Deal</mat-label>
                <input matInput
                       [formControlName]="'project_title'"
                       [placeholder]="'Search deals'"
                       [matAutocomplete]="matAutocomplete"
                       [spellcheck]="false">
            </mat-form-field>
            <mat-autocomplete #matAutocomplete="matAutocomplete" [disableRipple]="true" (optionSelected)='autocompleteSelected($event)'>

                <mat-option class="no-results"
                            *ngIf="results && !results.length">
                    No deals found!
                </mat-option>

                <mat-option *ngFor="let result of results" [value]="result">
                  {{ result.title }}
                </mat-option>

            </mat-autocomplete>

        </div>-->

    <!-- Notes -->
    <div class="notes">
      <mat-form-field class="treo-mat-textarea treo-mat-no-subscript">
        <mat-label>Description</mat-label>
        <textarea matInput treoAutogrow [formControlName]="'description'" [spellcheck]="false"></textarea>
      </mat-form-field>
    </div>
  </form>

  <!-- Checklist -->
  <task-details-checklist
    [task]="task"
    (checkListUpdated)="onCheckListUpdated($event)"
    [canEdit]="canEdit"
  ></task-details-checklist>

  <div class="flex flex-col mt-3">
    <div class="files-table">
      <div class="body">
        <div class="row" *ngFor="let fileResource of task.file_resources">
          <div class="col">
            <a (click)="downloadDocument(fileResource)">
              <mat-icon class="icon" [svgIcon]="'insert_drive_file'"></mat-icon>
            </a>
          </div>
          <div class="col">
            <a (click)="downloadDocument(fileResource)">{{ fileResource.name }}</a>
          </div>
          <div class="col">{{ fileResource.created_at | date: 'MMM dd, y' }}</div>
          <div class="col">{{ fileResource.user?.full_name }}</div>
          <div class="col">
            <button mat-icon-button class="delete-file" (click)="deleteFile(fileResource)" [disabled]="!canEdit">
              <mat-icon [svgIcon]="'delete'"></mat-icon>
            </button>
          </div>
        </div>
        <!-- <div class="row mt-2">
          <div>
            <button class="ml-2 xs:hidden add-task" mat-flat-button (click)="fileInput.click()">
              <mat-icon class="icon-size-20 mr-1" [svgIcon]="'backup'"></mat-icon>
              <input style="display: none" type="file" (change)="onFileChanged($event)" #fileInput />
              Upload Attachment
            </button>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <div class="mt-3 mb-3">
    <comment-view [relatedToId]="task.id" relatedToType="Task" [account]="account" [readonly]="!canEdit"></comment-view>
  </div>
</div>
